module.exports = __webpack_public_path__ + "img/10551396_L.73ce7725.png";